/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ShipmentReport } from "./ShipmentReport";
import {
  ShipmentReportFromJSON,
  ShipmentReportFromJSONTyped,
  ShipmentReportToJSON,
  ShipmentReportToJSONTyped,
} from "./ShipmentReport";

/**
 *
 * @export
 * @interface ProfitLossReport
 */
export interface ProfitLossReport {
  /**
   *
   * @type {number}
   * @memberof ProfitLossReport
   */
  numberShipments: number;
  /**
   *
   * @type {number}
   * @memberof ProfitLossReport
   */
  numberShipmentsWithAdditionalCustomerCharges: number;
  /**
   *
   * @type {number}
   * @memberof ProfitLossReport
   */
  numberShipmentsWhereCarrierPriceWasGreaterThanQuote: number;
  /**
   *
   * @type {number}
   * @memberof ProfitLossReport
   */
  numberShipmentsWhereCarrierPriceWasLessThanQuote: number;
  /**
   *
   * @type {number}
   * @memberof ProfitLossReport
   */
  averageProfit: number;
  /**
   *
   * @type {number}
   * @memberof ProfitLossReport
   */
  averageMarginPercentage: number;
  /**
   *
   * @type {number}
   * @memberof ProfitLossReport
   */
  averageInsuranceFreeMarginPercentage: number;
  /**
   *
   * @type {number}
   * @memberof ProfitLossReport
   */
  averageShipmentWeightLb: number;
  /**
   *
   * @type {number}
   * @memberof ProfitLossReport
   */
  averageShipmentVolumeCuft: number;
  /**
   *
   * @type {number}
   * @memberof ProfitLossReport
   */
  averageShipmentDensityPcf: number;
  /**
   *
   * @type {number}
   * @memberof ProfitLossReport
   */
  totalIncomingDollars: number;
  /**
   *
   * @type {number}
   * @memberof ProfitLossReport
   */
  totalOutgoingDollars: number;
  /**
   *
   * @type {number}
   * @memberof ProfitLossReport
   */
  totalIncomingDollarsWithoutInsurance: number;
  /**
   *
   * @type {number}
   * @memberof ProfitLossReport
   */
  totalIncomingDollarsFromInsurance: number;
  /**
   *
   * @type {Array<ShipmentReport>}
   * @memberof ProfitLossReport
   */
  shipmentLines: Array<ShipmentReport>;
}

/**
 * Check if a given object implements the ProfitLossReport interface.
 */
export function instanceOfProfitLossReport(
  value: object,
): value is ProfitLossReport {
  if (!("numberShipments" in value) || value["numberShipments"] === undefined)
    return false;
  if (
    !("numberShipmentsWithAdditionalCustomerCharges" in value) ||
    value["numberShipmentsWithAdditionalCustomerCharges"] === undefined
  )
    return false;
  if (
    !("numberShipmentsWhereCarrierPriceWasGreaterThanQuote" in value) ||
    value["numberShipmentsWhereCarrierPriceWasGreaterThanQuote"] === undefined
  )
    return false;
  if (
    !("numberShipmentsWhereCarrierPriceWasLessThanQuote" in value) ||
    value["numberShipmentsWhereCarrierPriceWasLessThanQuote"] === undefined
  )
    return false;
  if (!("averageProfit" in value) || value["averageProfit"] === undefined)
    return false;
  if (
    !("averageMarginPercentage" in value) ||
    value["averageMarginPercentage"] === undefined
  )
    return false;
  if (
    !("averageInsuranceFreeMarginPercentage" in value) ||
    value["averageInsuranceFreeMarginPercentage"] === undefined
  )
    return false;
  if (
    !("averageShipmentWeightLb" in value) ||
    value["averageShipmentWeightLb"] === undefined
  )
    return false;
  if (
    !("averageShipmentVolumeCuft" in value) ||
    value["averageShipmentVolumeCuft"] === undefined
  )
    return false;
  if (
    !("averageShipmentDensityPcf" in value) ||
    value["averageShipmentDensityPcf"] === undefined
  )
    return false;
  if (
    !("totalIncomingDollars" in value) ||
    value["totalIncomingDollars"] === undefined
  )
    return false;
  if (
    !("totalOutgoingDollars" in value) ||
    value["totalOutgoingDollars"] === undefined
  )
    return false;
  if (
    !("totalIncomingDollarsWithoutInsurance" in value) ||
    value["totalIncomingDollarsWithoutInsurance"] === undefined
  )
    return false;
  if (
    !("totalIncomingDollarsFromInsurance" in value) ||
    value["totalIncomingDollarsFromInsurance"] === undefined
  )
    return false;
  if (!("shipmentLines" in value) || value["shipmentLines"] === undefined)
    return false;
  return true;
}

export function ProfitLossReportFromJSON(json: any): ProfitLossReport {
  return ProfitLossReportFromJSONTyped(json, false);
}

export function ProfitLossReportFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ProfitLossReport {
  if (json == null) {
    return json;
  }
  return {
    numberShipments: json["numberShipments"],
    numberShipmentsWithAdditionalCustomerCharges:
      json["numberShipmentsWithAdditionalCustomerCharges"],
    numberShipmentsWhereCarrierPriceWasGreaterThanQuote:
      json["numberShipmentsWhereCarrierPriceWasGreaterThanQuote"],
    numberShipmentsWhereCarrierPriceWasLessThanQuote:
      json["numberShipmentsWhereCarrierPriceWasLessThanQuote"],
    averageProfit: json["averageProfit"],
    averageMarginPercentage: json["averageMarginPercentage"],
    averageInsuranceFreeMarginPercentage:
      json["averageInsuranceFreeMarginPercentage"],
    averageShipmentWeightLb: json["averageShipmentWeightLb"],
    averageShipmentVolumeCuft: json["averageShipmentVolumeCuft"],
    averageShipmentDensityPcf: json["averageShipmentDensityPcf"],
    totalIncomingDollars: json["totalIncomingDollars"],
    totalOutgoingDollars: json["totalOutgoingDollars"],
    totalIncomingDollarsWithoutInsurance:
      json["totalIncomingDollarsWithoutInsurance"],
    totalIncomingDollarsFromInsurance:
      json["totalIncomingDollarsFromInsurance"],
    shipmentLines: (json["shipmentLines"] as Array<any>).map(
      ShipmentReportFromJSON,
    ),
  };
}

export function ProfitLossReportToJSON(json: any): ProfitLossReport {
  return ProfitLossReportToJSONTyped(json, false);
}

export function ProfitLossReportToJSONTyped(
  value?: ProfitLossReport | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    numberShipments: value["numberShipments"],
    numberShipmentsWithAdditionalCustomerCharges:
      value["numberShipmentsWithAdditionalCustomerCharges"],
    numberShipmentsWhereCarrierPriceWasGreaterThanQuote:
      value["numberShipmentsWhereCarrierPriceWasGreaterThanQuote"],
    numberShipmentsWhereCarrierPriceWasLessThanQuote:
      value["numberShipmentsWhereCarrierPriceWasLessThanQuote"],
    averageProfit: value["averageProfit"],
    averageMarginPercentage: value["averageMarginPercentage"],
    averageInsuranceFreeMarginPercentage:
      value["averageInsuranceFreeMarginPercentage"],
    averageShipmentWeightLb: value["averageShipmentWeightLb"],
    averageShipmentVolumeCuft: value["averageShipmentVolumeCuft"],
    averageShipmentDensityPcf: value["averageShipmentDensityPcf"],
    totalIncomingDollars: value["totalIncomingDollars"],
    totalOutgoingDollars: value["totalOutgoingDollars"],
    totalIncomingDollarsWithoutInsurance:
      value["totalIncomingDollarsWithoutInsurance"],
    totalIncomingDollarsFromInsurance:
      value["totalIncomingDollarsFromInsurance"],
    shipmentLines: (value["shipmentLines"] as Array<any>).map(
      ShipmentReportToJSON,
    ),
  };
}
